// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"InputSearchPage_overlayWrapper__p4ELs","mainInputContainer":"InputSearchPage_mainInputContainer__GkX9z","resultContainer":"InputSearchPage_resultContainer__lvTLc"};